module.exports = __webpack_public_path__ + "media/images/europe-c04b22a0c50386d8f2eea4f76de1b292.png";